import React, { useEffect, useState, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Row, Col, FormGroup, Modal, OverlayTrigger, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { MultiSelect } from 'react-multi-select-component';
import { addUserRightsAssignmentAction } from '../../Supplier/store/Supplier.action';
import Loader from '../../../Components/Utility/Loader/Loader';
import * as systemMasterAction from '../../SystemMasters/Store/SystemMasters.action';
import { CloseIcon, InfoIcon, TickIcon } from '../../../bombiix-icon';
import { NewCheckbox } from '../../../Components/PIM/common';

function SupplierUserAssignmentModal({ show, toggle, data, brands, categoryType1, categoryType2, multiSubBrandList }) {
  const { t } = useTranslation('common');
  const { loggedInUserId, id, rightsAssignment } = data || {};
  const [brand, setBrand] = useState([]);
  const [subBrand, setSubBrand] = useState([]);
  const [category1, setCategory1] = useState([]);
  const [category2, setCategory2] = useState([]);
  const [isAllCategorySelected, setIsAllCategorySelected] = useState(false);
  const [isAllBrandSelected, setIsAllBrandSelected] = useState(false);
  const [isAllProductTypeSelected, setIsAllProductTypeSelected] = useState(false);
  const [brandsList, setBrandList] = useState([]);
  const [categoriesList1, setCategoriesList1] = useState([]);
  const [categoriesList2, setCategoriesList2] = useState([]);
  const [productTypesList, setProductTypesList] = useState([]);
  const [selectedProductTypes, setSelectedProductTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [subBrandAccess, setSubBrandAccess] = useState(false);

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm();

  const subBrandOptions = (multiSubBrandList || [])
    .filter((subbrand) => {
      if (!subbrand?.isActive) return false;
      if (brand?.length > 0 && subbrand?.brandId) {
        const selectedBrandIds = brand.map((b) => b.value);
        return selectedBrandIds.includes(subbrand?.brandId);
      }
      return true;
    })
    .map((subbrand) => ({
      label: subbrand?.name,
      value: subbrand?._id,
    }))
    .filter((option) => option?.value);
  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      try {
        const res = await dispatch(systemMasterAction.getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  useEffect(() => {
    const fetchSubbrandAccess = async () => {
      const subBrandAccessRes = await dispatch(systemMasterAction.getSubBrandAccess());
      setSubBrandAccess(subBrandAccessRes?.data || false);
    };
    fetchSubbrandAccess();
  }, [dispatch]);
  useEffect(() => {
    const fetchSubBrands = async () => {
      try {
        const params = {
          isActive: true,
        };
        if (brand?.length > 0) {
          params.brandId = brand.map((b) => b.value);
          await dispatch(systemMasterAction.getMultiSubBrandDetails(params));
        }
      } catch (error) {
        console.error('Failed to fetch sub brands:', error);
      }
    };
    if (show && brand?.length > 0) {
      fetchSubBrands();
    }
  }, [dispatch, show, brand]);

  useEffect(() => {
    setBrandList(brands || []);
    setCategoriesList1(categoryType1 || []);
    setCategoriesList2(categoryType2 || []);
  }, [brands, categoryType1, categoryType2]);

  const firstExuit = useCallback(async () => {
    let brandListArray = [];
    let subBrandListArray = [];
    let category1ListArray = [];
    let category2ListArray = [];

    setIsAllBrandSelected(false);
    setIsAllCategorySelected(false);
    setIsAllProductTypeSelected(false);

    const hasAssignments =
      JSON.stringify(rightsAssignment) !== '{}' &&
      (rightsAssignment?.brands || rightsAssignment?.typeOneCategories || rightsAssignment?.typeTwoCategories || rightsAssignment?.productTypes);

    if (hasAssignments) {
      if (rightsAssignment.brands === true) {
        setIsAllBrandSelected(true);
        brandListArray = brands || [];
      } else if (Array.isArray(rightsAssignment.brands) && brands?.length > 0) {
        brandListArray = brands.filter((brand) => rightsAssignment.brands.includes(brand.value)).map((brd) => ({ label: brd.label, value: brd.value }));
      }

      if (rightsAssignment.subBrands === true) {
        subBrandListArray = (multiSubBrandList || [])
          .filter((sb) => sb?.isActive)
          .map((sb) => ({ label: sb?.name, value: sb?._id }))
          .filter((option) => option?.value);
      } else if (Array.isArray(rightsAssignment.subBrands) && multiSubBrandList?.length > 0) {
        subBrandListArray = (multiSubBrandList || [])
          .filter((sb) => sb?.isActive && rightsAssignment.subBrands.includes(sb?._id))
          .map((sb) => ({ label: sb?.name, value: sb?._id }))
          .filter((option) => option?.value);
      }

      if (rightsAssignment.typeOneCategories === true) {
        category1ListArray = categoryType1 || [];
      } else if (Array.isArray(rightsAssignment.typeOneCategories)) {
        category1ListArray = (categoryType1 || [])
          .filter((cate) => rightsAssignment.typeOneCategories.includes(cate.value))
          .map((prod) => ({ label: prod.label, value: prod.value }));
      }

      if (rightsAssignment.typeTwoCategories === true) {
        category2ListArray = categoryType2 || [];
      } else if (Array.isArray(rightsAssignment.typeTwoCategories)) {
        category2ListArray = (categoryType2 || [])
          .filter((cate) => rightsAssignment.typeTwoCategories.includes(cate.value))
          .map((prod) => ({ label: prod.label, value: prod.value }));
      }

      if (rightsAssignment.typeOneCategories === true && rightsAssignment.typeTwoCategories === true) {
        setIsAllCategorySelected(true);
      }

      if (rightsAssignment?.productTypes === true) {
        setIsAllProductTypeSelected(true);
      }
    }

    if (data) {
      const obj = {
        brand: brandListArray,
        subBrand: subBrandListArray,
        category1: category1ListArray,
        category2: category2ListArray,
      };

      for (const [key, value] of Object.entries(obj)) {
        setValue(key, value);
        if (key === 'brand') {
          setBrand(value);
        }
        if (key === 'subBrand') {
          setSubBrand(value);
        }
        if (key === 'category1') {
          setCategory1(value);
        }
        if (key === 'category2') {
          setCategory2(value);
        }
      }
    }
  }, [rightsAssignment, brands, multiSubBrandList, categoryType1, categoryType2, data, setValue]);

  useEffect(() => {
    if (show && !isInitialized) {
      firstExuit();
      setIsInitialized(true);
    } else if (!show && isInitialized) {
      // Reset when modal closes
      setIsInitialized(false);
    }
  }, [show, isInitialized, firstExuit]);

  useEffect(() => {
    if (show && multiSubBrandList && multiSubBrandList.length > 0 && rightsAssignment && rightsAssignment.subBrands) {
      let subBrandListArray = [];

      if (Array.isArray(rightsAssignment.subBrands)) {
        subBrandListArray = multiSubBrandList
          .filter((sb) => sb?.isActive && rightsAssignment.subBrands.includes(sb?._id))
          .map((sb) => ({ label: sb?.name, value: sb?._id }))
          .filter((option) => option?.value);
      } else if (rightsAssignment.subBrands === true) {
        subBrandListArray = multiSubBrandList
          .filter((sb) => sb?.isActive)
          .map((sb) => ({ label: sb?.name, value: sb?._id }))
          .filter((option) => option?.value);
      }

      const currentSubBrandString = JSON.stringify(subBrand);
      const newSubBrandString = JSON.stringify(subBrandListArray);

      if (currentSubBrandString !== newSubBrandString) {
        setValue('subBrand', subBrandListArray);
        setSubBrand(subBrandListArray);
      }
    }
  }, [show, multiSubBrandList, rightsAssignment, setValue]);

  useEffect(() => {
    const fetchPCTypes = async () => {
      try {
        const res = await dispatch(
          systemMasterAction.getPCTypesDetails(
            {
              loggedInUserId,
              isActive: true,
              tier: 'Tier1',
            },
            true,
          ),
        );
        const list = Array.isArray(res) ? res : res?.data || [];
        const mapped = (list || []).map((pt) => ({ label: pt?.name, value: pt?._id })).filter((x) => x?.value);
        setProductTypesList(mapped);
        if (rightsAssignment?.productTypes === true) {
          setSelectedProductTypes(mapped);
          setIsAllProductTypeSelected(true);
        } else if (Array.isArray(rightsAssignment?.productTypes)) {
          const sel = mapped.filter((m) => rightsAssignment.productTypes?.includes(m.value));
          setSelectedProductTypes(sel);
          setIsAllProductTypeSelected(sel.length === mapped.length && mapped.length > 0);
        }
      } catch (e) {
        setProductTypesList([]);
      }
    };
    if (loggedInUserId) {
      fetchPCTypes();
    }
  }, [dispatch, loggedInUserId, rightsAssignment]);

  const onSubmitMethod = async (brandAndcategoryData) => {
    if (subBrandAccess && (brandAndcategoryData?.subBrand || []).length === 0) {
      setError('subBrand', { type: 'required' });
      return;
    }

    if (catBasedOnPTData && !selectedProductTypes?.length) {
      setError('productTypes', { type: 'required' });
      return;
    }
    setIsLoading(true);
    const allData = {
      brands: brandAndcategoryData.brand.map((item) => item.value),
      subBrands: (brandAndcategoryData.subBrand || []).map((item) => item.value),
      typeOneCategories: brandAndcategoryData.category1.map((item) => item.value),
      typeTwoCategories: brandAndcategoryData.category2.map((item) => item.value),
      productTypes: selectedProductTypes.map((item) => item.value),
    };

    const finalDataObj = {
      loggedInUserId,
      brands: isAllBrandSelected ? true : JSON.stringify(allData.brands),
      subBrands: JSON.stringify(allData.subBrands),
      typeOneCategories: isAllCategorySelected ? true : JSON.stringify(allData.typeOneCategories),
      typeTwoCategories: isAllCategorySelected ? true : JSON.stringify(allData.typeTwoCategories),
      productTypes: isAllProductTypeSelected ? true : JSON.stringify(allData.productTypes),
      userId: id,
      section: 'supplierOverview',
      action: 'addEdit',
    };
    await dispatch(addUserRightsAssignmentAction(finalDataObj, t));
    setIsLoading(false);
    toggle();
  };

  const onSelectBrandCheckBox = (e) => {
    const allBrandChecked = e.target.checked;
    setIsAllBrandSelected(allBrandChecked);

    if (allBrandChecked) {
      setValue('brand', brandsList);
      setBrand(brandsList);
    } else {
      setValue('brand', []);
      setBrand([]);
      setValue('subBrand', []);
      setSubBrand([]);
    }
  };

  const onSelectCategoryCheckBox = (e) => {
    const allCategory1Selected = e.target.checked;

    allCategory1Selected ? setValue('category1', categoriesList1) : setValue('category1', []);
    allCategory1Selected ? setCategory1(categoriesList1) : setCategory1([]);

    allCategory1Selected ? setValue('category2', categoriesList2) : setValue('category2', []);
    allCategory1Selected ? setCategory2(categoriesList2) : setCategory2([]);
    setIsAllCategorySelected(allCategory1Selected);
  };

  const onSelectProductTypeCheckBox = (e) => {
    const allPTChecked = e.target.checked;
    setIsAllProductTypeSelected(allPTChecked);
    allPTChecked ? setSelectedProductTypes(productTypesList) : setSelectedProductTypes([]);
  };

  return (
    <Modal className="custom-modal modal-medium-3x supplier-overview-modal" size="lg" show={show} onHide={toggle} backdrop="static" centered>
      <Modal.Header className="d-flex justify-content-center position-relative">
        <Modal.Title className="w-100 text-center">
          <strong>{t('SUPPLIER_USER_ASSIGNMENT.MODAL_TITLE')}</strong>
        </Modal.Title>
        <CloseIcon size={28} onClick={toggle} className="cursor-pointer position-absolute" style={{ right: 16, top: '50%', transform: 'translateY(-50%)' }} />
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="d-flex my-3">
              <div className="d-flex align-items-center">
                <div className="mr-2">
                  <div className="d-inline-flex">
                    <NewCheckbox onChange={(e) => onSelectBrandCheckBox(e)} name="allBrand" id="checkAllBrand" checked={isAllBrandSelected} />
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <strong>{t('ADD_EDIT_BRAND_CATEGORY.ALL_BRAND')}</strong>
                  <div>
                    <OverlayTrigger
                      placement="bottom"
                      trigger="click"
                      rootClose
                      overlay={
                        <Popover className="custom-popover">
                          <Popover.Content>{t('ADD_EDIT_BRAND_CATEGORY.MEGGASES')}</Popover.Content>
                        </Popover>
                      }
                    >
                      <span className="d-inline-flex mx-2"><InfoIcon size={24} /></span>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="mr-2 ml-2">
                  <div className="d-inline-flex">
                    <NewCheckbox onChange={(e) => onSelectCategoryCheckBox(e)} name="checkAllCategory" id="allCategory" checked={isAllCategorySelected} />
                  </div>
                </div>
                <div>
                  <div className="d-flex align-items-center">
                    <strong>{t('ADD_EDIT_BRAND_CATEGORY.ALL_CATEGORIES')}</strong>
                    <OverlayTrigger
                      placement="bottom"
                      trigger="click"
                      rootClose
                      overlay={
                        <Popover className="custom-popover">
                          <Popover.Content>{t('ADD_EDIT_BRAND_CATEGORY.BRANDS_MESSAGE')}</Popover.Content>
                        </Popover>
                      }
                    >
                      <span className="d-inline-flex mx-2"><InfoIcon size={24} /></span>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
              {catBasedOnPTData && (
                <div className="d-flex align-items-center">
                  <div className="mr-2 ml-2">
                    <div className="d-inline-flex">
                    <NewCheckbox onChange={(e) => onSelectProductTypeCheckBox(e)} name="checkAllProductType" id="allProductType" checked={isAllProductTypeSelected} />
                  </div>
                  </div>
                  <div>
                    <div className="d-flex align-items-center">
                      <strong>{t('ADD_EDIT_BRAND_CATEGORY.ALL_PRODUCT_TYPES')}</strong>
                      <OverlayTrigger
                        placement="bottom"
                        trigger="click"
                        rootClose
                        overlay={
                          <Popover className="custom-popover">
                            <Popover.Content>{t('ADD_EDIT_BRAND_CATEGORY.PRODUCT_TYPES_MESSAGE')}</Popover.Content>
                          </Popover>
                        }
                      >
                        <span className="d-inline-flex mx-2"><InfoIcon size={24} /></span>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <Row>
              <Col lg="3">
                <FormGroup>
                  <div className="common-react-select mb-0">
                    <p className="field-name">
                      {t('ADD_EDIT_BRAND_CATEGORY.BRAND')}
                      <span className="asterisk">*</span>
                    </p>
                    <MultiSelect
                      name="brand"
                      {...register('brand', { required: true })}
                      options={brandsList}
                      className="product-custom-multiselect common-new-multiselect w-100"
                      value={brand}
                      onChange={(val) => {
                        setValue('brand', val);
                        setBrand(val);
                        setIsAllBrandSelected(val.length === brandsList.length && brandsList.length > 0);
                        if (val.length === 0) {
                          setValue('subBrand', []);
                          setSubBrand([]);
                        } else {
                          const selectedBrandIds = val.map((b) => b.value);
                          const validSubBrands = subBrand.filter((sb) => {
                            const subBrandData = multiSubBrandList?.find((s) => s._id === sb.value);
                            return subBrandData && selectedBrandIds.includes(subBrandData.brandId);
                          });
                          setValue('subBrand', validSubBrands);
                          setSubBrand(validSubBrands);
                        }
                      }}
                      labelledBy={t('ADD_EDIT_BRAND_CATEGORY.BRAND')}
                    />
                    {errors.brand && <span className="error-message">{t('ADD_EDIT_BRAND_CATEGORY.BRAND_REQUIRED')}</span>}
                  </div>
                </FormGroup>
              </Col>
              {subBrandAccess && (
                <Col md={3}>
                  <FormGroup>
                    <div className="common-react-select mb-0">
                      <p className="field-name">
                        {t('REPORTS.SUBBRAND')}
                        <span className="asterisk">*</span>
                      </p>
                      <MultiSelect
                        name="subBrand"
                        {...register('subBrand', { required: true })}
                        options={subBrandOptions}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={subBrand}
                        labelledBy={t('POMS.GRADING_GROUP.TOP_GROUP_BAR.SUB_BRAND_NOT_SELECTED')}
                        onChange={(val) => {
                          setValue('subBrand', val);
                          setSubBrand(val);
                        }}
                      />
                      {errors.subBrand && <span className="error-message">{t('ADD_EDIT_BRAND_CATEGORY.SUB_BRAND_REQUIRED')}</span>}
                    </div>
                  </FormGroup>
                </Col>
              )}
              {catBasedOnPTData && (
                <Col md={3}>
                  <div className="common-react-select mb-0">
                    <p className="field-name">
                      {t('ADD_EDIT_BRAND_CATEGORY.PRODUCT_TYPE')}
                      <span className="asterisk">*</span>
                    </p>
                    <MultiSelect
                      name="productTypes"
                      {...register('productTypes')}
                      options={productTypesList}
                      className="product-custom-multiselect common-new-multiselect w-100"
                      value={selectedProductTypes}
                      labelledBy={t('ADD_EDIT_BRAND_CATEGORY.SELECT_PRODUCT_TYPES')}
                      onChange={(val) => {
                        setSelectedProductTypes(val);
                        setIsAllProductTypeSelected(val.length === productTypesList.length && productTypesList.length > 0);
                        setValue('productTypes', val, { shouldValidate: true });
                        if (val?.length) {
                          clearErrors('productTypes');
                        }
                      }}
                    />
                    {errors?.productTypes && <small className="error-message">Product Type is required</small>}
                  </div>
                </Col>
              )}
              <Col lg="3">
                <FormGroup>
                  <div className="common-react-select mb-0">
                    <p className="field-name">
                      {t('ADD_EDIT_BRAND_CATEGORY.CATEGORY_1')}
                      <span className="asterisk">*</span>{' '}
                    </p>
                    <MultiSelect
                      name="category1"
                      {...register('category1', { required: true })}
                      options={categoriesList1}
                      className="product-custom-multiselect common-new-multiselect w-100"
                      value={category1}
                      onChange={(val) => {
                        setValue('category1', val);
                        setCategory1(val);
                        setIsAllCategorySelected(val.length === categoriesList1.length && categoriesList1.length > 0);
                      }}
                      labelledBy={t('ADD_EDIT_BRAND_CATEGORY.CATEGORY_1')}
                    />
                    {errors.category1 && <span className="error-message">{t('ADD_EDIT_BRAND_CATEGORY.CATEGORY_1_REQUIRED')}</span>}
                  </div>
                </FormGroup>
              </Col>
              <Col lg="3">
                <FormGroup>
                  <div className="common-react-select mb-0">
                    <p className="field-name">
                      {t('ADD_EDIT_BRAND_CATEGORY.CATEGORY_2')}
                      <span className="asterisk">*</span>{' '}
                    </p>
                    <MultiSelect
                      name="category2"
                      {...register('category2', { required: true })}
                      options={categoriesList2}
                      className="product-custom-multiselect common-new-multiselect w-100"
                      value={category2}
                      onChange={(val) => {
                        setValue('category2', val);
                        setCategory2(val);
                        setIsAllCategorySelected(val.length === categoriesList2.length && category1.length === categoriesList1.length);
                      }}
                      labelledBy={t('ADD_EDIT_BRAND_CATEGORY.CATEGORY_2')}
                    />
                    {errors.category2 && <span className="error-message">{t('ADD_EDIT_BRAND_CATEGORY.CATEGORY_2_REQUIRED')}</span>}
                  </div>
                </FormGroup>
              </Col>
            </Row>

            <div className="common-model-footer d-flex justify-content-end">
              <button type="button" aria-label="button" className="btn p-0" onClick={handleSubmit(onSubmitMethod)}>
                <TickIcon size={28} />
              </button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default SupplierUserAssignmentModal;
